import { InjectedAppSettings } from 'core/AppSettings.types';
import { alphanumeric } from 'core/helpers/alphanumeric';

export const INJECTED_APP_SETTINGS: InjectedAppSettings = {
  apiKey: '',
  apiUrl: '#{WebApiAppHostUri}',
  authUrl: '#{appSettings:LoginUri}',
  beamerProductId: '#{BeamerProductId.DomainRestricted}',
  bingMapsApiKey: '#{BingMapsApiKey.DomainRestricted}',
  cumulusApiUrl: '#{CumulusAppHostUri}',
  debug: '#{Debug}',
  environment: import.meta.env.MODE,
  es1Url: '#{MvcHostUri}',
  exportsUrl: '#{CumulusExporterAppHostUri}',
  // There are a number of rules set up in Cloudfront to handle file caching depending
  // on the type of request. This value is currently used for browser cache busting
  // and I want to make sure any requests that include it aren't misinterpreted as
  // a particular file type, so making the value alphanumeric just in case.
  frontendVersion: alphanumeric('#{OmnisFrontendVersion}'),
  googleAnalyticsMeasurementId: '#{GoogleAnalyticsMeasurementId}',
  googleMapsApiKey: '#{GoogleMapsApiKey.DomainRestricted}',
  graphQLUrl: '#{GraphQLApiUri}',
  hasProject: '#{HasProject}',
  icpCertificate: '#{China-IcpRegistrations}',
  internetSecurityNumber: '#{China-InternetSecurityNumber}',
  internetSecurityNumberText: '#{China-InternetSecurityNumberText}',
  isCommunity: '#{IsCommunity}',
  mapboxApiKey: '#{MapboxApiKey.DomainRestricted}',
  omnisAppHost: '#{OmnisAppHost}',
  omnisCommunityAppHost: '#{OmnisCommunityAppHost}',
  omnisUrl: '#{OmnisHostUri}',
  publicApiUrl: '#{ES2VersionedApiUri}',
  releaseNumber: '#{Octopus.Release.Number}',
  reportsServerUrl: '#{ReportsAppHostUri}',
  wsUrl: '#{WSAppHostUri}',
};
